<script lang="ts" setup>
const props = defineProps<{
  items?: unknown[]
  itemTitle?: string
  itemValue?: string
  label?: string
  noDataText?: string
  multiple?: boolean
  variant?: 'outlined' | 'plain' | 'filled' | 'underlined' | 'solo' | 'solo-inverted' | 'solo-filled'
  chips?: boolean
  isLoading?: boolean
}>()

const modelValueComputed = defineModel<string[]>({ default: [] })
</script>

<template>
  <v-autocomplete v-bind="props" v-model="modelValueComputed" :variant="props.variant || 'filled'" :loading="isLoading">
    <template #chip="{ item, props: chipProps }">
      <skr-chip
        :key="item[props.itemTitle || 'title']"
        v-bind="chipProps"
        closable
        size="small"
        color="primary"
        @click:close="modelValueComputed.filter(val => val !== item.value)"
      >
        {{ item.title }}
      </skr-chip>
    </template>
    <template v-if="$slots.item" #item="slotProps">
      <slot name="item" v-bind="slotProps" />
    </template>
    <slot />
  </v-autocomplete>
</template>

<style lang="scss" scoped>
::v-deep(.v-autocomplete__selection) {
  margin: $bw 0 $bw 0;
}
</style>
